import React from 'react'

const Image = ({src, alt, className, lazyLoad = true}) => {
  return (
    <img src={src} alt={alt} className={`object-cover ${className}`} loading={lazyLoad ? "lazy" : "eager"} />
  )
}

export default Image